export enum BookingStage {
  Location = 0,
  ServiceSelection = 1,
  AppointmentOptions = 2,
  CustomerInfo = 3,
  VehicleInfo = 4,
  Confirmed = 5,
  Bailout = 6,
  SkipToForm = 7,
  Submitting = 8,
  BookingFailed = 9,
}

export const REDIRECT_STAGES: BookingStage[] = [
  BookingStage.Confirmed,
  BookingStage.Submitting,
  BookingStage.BookingFailed,
];

export const ACTIVE_BOOKING_STAGES: BookingStage[] = [
  BookingStage.ServiceSelection,
  BookingStage.AppointmentOptions,
  BookingStage.CustomerInfo,
  BookingStage.VehicleInfo,
  BookingStage.Confirmed,
  BookingStage.Bailout,
  BookingStage.SkipToForm,
  BookingStage.Submitting,
  BookingStage.BookingFailed,
];

export const BOOKING_FLOW_STAGES: BookingStage[] = [
  BookingStage.Location,
  BookingStage.ServiceSelection,
  BookingStage.AppointmentOptions,
  BookingStage.CustomerInfo,
  BookingStage.VehicleInfo,
  BookingStage.Confirmed,
  BookingStage.Bailout,
  BookingStage.SkipToForm,
  BookingStage.Submitting,
  BookingStage.BookingFailed,
];

export const ACTIVE_NAVIGATION_STAGES: BookingStage[] = [
  BookingStage.ServiceSelection,
  BookingStage.AppointmentOptions,
  BookingStage.CustomerInfo,
  BookingStage.VehicleInfo,
];

export const isBookingFlowStage = (stage?: number): boolean =>
  BOOKING_FLOW_STAGES.includes((stage ?? -1) as BookingStage);
